import React, { useEffect, useState } from "react";
import styles from "./Index.module.scss";
import { Drawer } from "antd";
import ConsultationHistoryModalContent from "./ConsultationHistoryModalContent";

const ConsultationHistory = () => {
  const consultationHistory_dummy = [
    {
      appointmentId: 1,
      doctorName: "Dr. Smith",
      reasonForVisit: "Cough and Cold",
      appointmentDate: "2023-08-10",
      action: "Prescribed medication",
    },
    {
      appointmentId: 2,
      doctorName: "Dr. Johnson",
      reasonForVisit: "Back Pain",
      appointmentDate: "2023-08-12",
      action: "Suggested physical therapy",
    },
    {
      appointmentId: 3,
      doctorName: "Dr. Williams",
      reasonForVisit: "Fever",
      appointmentDate: "2023-08-15",
      action: "Advised rest and fluids",
    },
    {
      appointmentId: 4,
      doctorName: "Dr. Brown",
      reasonForVisit: "Headache",
      appointmentDate: "2023-08-18",
      action: "Recommended relaxation techniques",
    },
    {
      appointmentId: 5,
      doctorName: "Dr. Miller",
      reasonForVisit: "Annual Checkup",
      appointmentDate: "2023-08-20",
      action: "Reviewed overall health",
    },
  ];
 
  const [consultationHistory, setConsultationHistory] = useState();
  const [isModalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setConsultationHistory(consultationHistory_dummy);
  }, []);

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const moreButtonOnClick = (id)=>{
    setModalOpen(true)
  }

  return (
    <div className={styles.container}>
      <div className="appoinment-table-wrap">
        <table className={styles.consultationHistoryTable}>
          <tr>
            <th>Mode</th>
            <th>Doctor Name</th>
            <th>Complaint</th>
            <th>Consulted On</th>
            <th>Action</th>
            <th></th>
          </tr>

          <tbody>
            {
              //loaded?

              consultationHistory && consultationHistory.length > 0 ? (
                consultationHistory.map((element, key) => {
                  return (
                    <tr>
                      <td>Video</td>
                      <td>{element.doctorName}</td>
                      <td>
                        {element.reasonForVisit ? element.reasonForVisit : "NA"}
                      </td>
                      <td>{element.appointmentDate}</td>
                      <td>{element.action ? element.action : "NA"}</td>
                      <td style={{ textAlign: "right" }}>
                        <button
                          onClick={() => {
                            moreButtonOnClick(element.appointmentId);
                          }}
                          className={styles.moreBtn}
                        >
                          More
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={6}>
                    <div className="no-data">
                      {/* <img src={require('../../../../../../assets/RpmAssets/PNGIcons/more.png')} alt="" /> */}

                      <span>No data available</span>
                    </div>
                  </td>
                </tr>
              )
              //:""
            }
          </tbody>
        </table>
      </div>

      <Drawer
        className={styles.consultationHistoryDetailsDrawer}
        closeIcon={false}
        title={false}
        placement="right"
        onClose={handleCloseModal}
        open={isModalOpen}
      >
       <ConsultationHistoryModalContent/>
      </Drawer>
    </div>
  );
};

export default ConsultationHistory;
